import React from 'react';

type StatsBoxesProps = {
    quarters5d: { days: number; hours: number }[];
    quarters6d: { days: number; hours: number }[];
    workWeek: 'five' | 'six';
};

const StatsBoxes = ({ quarters5d, quarters6d, workWeek }: StatsBoxesProps) => {
    const renderStats = (quarters: { days: number; hours: number }[], label: string) => {
        const totalDays = quarters.reduce((a, b) => a + b.days, 0);
        const totalHours = quarters.reduce((a, b) => a + b.hours, 0);
        const avgDays = (totalDays / 12).toFixed(2).replace('.', ',');
        const avgHours = (totalHours / 12).toFixed(2).replace('.', ',');

        return (
            <div className="border rounded-lg p-4 bg-gray-50 max-w-md w-full shadow-sm text-center">
                <h3 className="font-semibold mb-2">{label}</h3>
                {quarters.map((q, i) => (
                    <p key={i}>
                        {i + 1} ketvirtis: {q.days} darbo d., {q.hours} val.
                    </p>
                ))}
                <hr className="my-2" />
                <p>Viso: {totalDays} darbo d., {totalHours} val.</p>
                <p>Vidutinis per mėn: {avgDays} d., {avgHours} val.</p>
            </div>
        );
    };

    return (
        <div className="flex justify-center mt-6 text-sm">
            {workWeek === 'five'
                ? renderStats(quarters5d, '5 dienų darbo savaitė')
                : renderStats(quarters6d, '6 dienų darbo savaitė')}
        </div>
    );
};

export default StatsBoxes;
